// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowUpRightFromSquare16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-up-right-from-square': IconArrowUpRightFromSquare;
    }
}

/**
 * The icon component for the 'arrowUpRightFromSquare' icon
 */
export class IconArrowUpRightFromSquare extends IconSvg {
    public constructor() {
        super(arrowUpRightFromSquare16X16);
    }
}

registerIconSvg('icon-arrow-up-right-from-square', IconArrowUpRightFromSquare);
export const iconArrowUpRightFromSquareTag = 'nimble-icon-arrow-up-right-from-square';
